import { dual, pipe } from '../../Function/dist/effect-Function.esm.js';
import { logLevelAll, logLevelFatal, logLevelError, logLevelWarning, logLevelInfo, logLevelDebug, logLevelTrace, logLevelNone, allLogLevels, fiberRefLocally, currentLogLevel } from '../../internal/core.esm.js';
import { Order as Order$1 } from '../../Number/dist/effect-Number.esm.js';
import { mapInput, lessThan as lessThan$1, lessThanOrEqualTo, greaterThan as greaterThan$1, greaterThanOrEqualTo } from '../../Order/dist/effect-Order.esm.js';

/**
 * @since 2.0.0
 */

/**
 * A `LogLevel` represents the log level associated with an individual logging
 * operation. Log levels are used both to describe the granularity (or
 * importance) of individual log statements, as well as to enable tuning
 * verbosity of log output.
 *
 * @since 2.0.0
 * @category model
 * @property ordinal - The priority of the log message. Larger values indicate higher priority.
 * @property label - A label associated with the log level.
 * @property syslog -The syslog severity level of the log level.
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category model
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const All = logLevelAll;

/**
 * @since 2.0.0
 * @category constructors
 */
const Fatal = logLevelFatal;

/**
 * @since 2.0.0
 * @category constructors
 */
const Error = logLevelError;

/**
 * @since 2.0.0
 * @category constructors
 */
const Warning = logLevelWarning;

/**
 * @since 2.0.0
 * @category constructors
 */
const Info = logLevelInfo;

/**
 * @since 2.0.0
 * @category constructors
 */
const Debug = logLevelDebug;

/**
 * @since 2.0.0
 * @category constructors
 */
const Trace = logLevelTrace;

/**
 * @since 2.0.0
 * @category constructors
 */
const None = logLevelNone;

/**
 * @since 2.0.0
 * @category constructors
 */
const allLevels = allLogLevels;

/**
 * Locally applies the specified `LogLevel` to an `Effect` workflow, reverting
 * to the previous `LogLevel` after the `Effect` workflow completes.
 *
 * @since 2.0.0
 * @category utils
 */
const locally = /*#__PURE__*/dual(2, (use, self) => fiberRefLocally(use, currentLogLevel, self));

/**
 * @since 2.0.0
 * @category instances
 */
const Order = /*#__PURE__*/pipe(Order$1, /*#__PURE__*/mapInput(level => level.ordinal));

/**
 * @since 2.0.0
 * @category ordering
 */
const lessThan = /*#__PURE__*/lessThan$1(Order);

/**
 * @since 2.0.0
 * @category ordering
 */
const lessThanEqual = /*#__PURE__*/lessThanOrEqualTo(Order);

/**
 * @since 2.0.0
 * @category ordering
 */
const greaterThan = /*#__PURE__*/greaterThan$1(Order);

/**
 * @since 2.0.0
 * @category ordering
 */
const greaterThanEqual = /*#__PURE__*/greaterThanOrEqualTo(Order);

/**
 * @since 2.0.0
 * @category conversions
 */
const fromLiteral = _ => {
  switch (_) {
    case "All":
      {
        return All;
      }
    case "Debug":
      {
        return Debug;
      }
    case "Error":
      {
        return Error;
      }
    case "Fatal":
      {
        return Fatal;
      }
    case "Info":
      {
        return Info;
      }
    case "Trace":
      {
        return Trace;
      }
    case "None":
      {
        return None;
      }
    case "Warning":
      {
        return Warning;
      }
  }
};

export { All, Debug, Error, Fatal, Info, None, Order, Trace, Warning, allLevels, fromLiteral, greaterThan, greaterThanEqual, lessThan, lessThanEqual, locally };
